export const environment = {
  production: false,
  API_URL: 'https://empreendasalvador.salvador.ba.gov.br/api',
  USER_TYPE: {
    CONTRACTOR: 'c',
    FREELANCER: 'f',
    ADM: 'adm'
  }
};
